import React from 'react'
import {
  GelForm,
  GelFormField,
  useGelFormData,
  GelNumberInput,
  GelButton,
  GelBoxLayout
} from '@tal-gel/components'
import styled from '@emotion/styled'

const StretchWrapper = styled.div`
  & > div > div {
    flex-grow: 1;
  }
`

const TwoNumberInputs = ({ question, onQuestionAnswered }) => {
  const { formData, onFormDataChange, onFormDataReset, resetForm } =
    useGelFormData({
      first: null,
      second: null
    })

  const onSubmit = () => {
    const result = {
      height: `${formData.first} cm`,
      weight: `${formData.second} kg`
    }

    onQuestionAnswered({ [question.apiName]: result })
  }

  const onError = (error) => {
    console.error('error', error)
  }

  return (
    <GelForm
      labelAtTop
      disableOnSubmit
      preventSubmitOnInvalid
      onSubmit={onSubmit}
      reset={resetForm}
      onReset={onFormDataReset}
      onError={onError}
    >
      <StretchWrapper>
        <GelBoxLayout
          space='auto'
          distribution='start'
          style={{ marginBottom: '24px' }}
        >
          <GelFormField
            label={question.answers[0].title}
            tooltip='Centimeters'
            style={{ marginBottom: '12px' }}
          >
            <GelNumberInput
              name='first'
              value={formData.first}
              // As `event.target.value` is always a string,
              // the second param `true` indicates that it
              // should be converted into a numeric value
              onChange={(event) => {
                event.persist()
                onFormDataChange(event, true)
              }}
              required
              gte={99}
              lte={251}
              errorMsg={{
                required: 'This field is required',
                compare: 'Height must be >= 99 and <= 251',
                format: 'Height format is incorrect'
              }}
            />
          </GelFormField>
          <GelFormField
            label={question.answers[1].title}
            tooltip='Kilograms'
            style={{ marginBottom: '12px' }}
          >
            <GelNumberInput
              name='second'
              value={formData.second}
              onChange={(event) => {
                event.persist()
                onFormDataChange(event, true)
              }}
              required
              gte={39}
              lte={595}
              errorMsg={{
                required: 'This field is required',
                compare: 'Weight must be >= 39 and <= 595',
                format: 'Weight format is incorrect'
              }}
            />
          </GelFormField>
        </GelBoxLayout>
      </StretchWrapper>
      <GelBoxLayout space='auto' distribution='start'>
        <GelFormField>
          <GelButton
            name='' // Makes it a managed component
            primary
            medium
            submit
          >
            Submit
          </GelButton>
        </GelFormField>
        <GelFormField>
          <GelButton
            name='' // Makes it a managed component
            secondary
            medium
            onClick={onFormDataReset}
          >
            Reset
          </GelButton>
        </GelFormField>
      </GelBoxLayout>
    </GelForm>
  )
}

export default TwoNumberInputs
